"use client"

import Image from "next/image"
import { motion, useScroll, useTransform } from "motion/react"
import { useRef } from "react"
import { cn } from "@/lib/utils"

interface ParallaxHeroImageProps {
  src: string
  alt: string
  width?: number
  height?: number
  priority?: boolean
  className?: string
  /** Parallax intensity — how many pixels the image shifts. Default 40 */
  intensity?: number
}

export function ParallaxHeroImage({ src, alt, width = 1920, height = 500, priority = false, className, intensity = 40 }: ParallaxHeroImageProps) {
  const ref = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  })
  const y = useTransform(scrollYProgress, [0, 1], [-intensity, intensity])

  return (
    <div
      ref={ref}
      className={cn(
        "rounded-[2rem] p-1.5 overflow-hidden",
        "bg-foreground/[0.02] ring-1 ring-foreground/5",
        "dark:bg-background/[0.06] dark:ring-foreground/10",
        className
      )}
    >
      <div className="rounded-[calc(2rem-0.375rem)] overflow-hidden relative">
        <motion.div
          style={{ y }}
          suppressHydrationWarning
        >
          <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            className="w-full h-auto object-cover"
            priority={priority}
          />
        </motion.div>
      </div>
    </div>
  )
}
